module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "dense",
      "color": !_vm.ticket.abierto ? 'secondary' : ''
    }
  }, [_c('v-divider', {
    attrs: {
      "inset": "inset"
    }
  }), _c('v-list-item', {
    key: _vm.ticket.title,
    on: {
      "click": function($event) {
        return _vm.handlerClick(_vm.ticket.numero)
      }
    }
  }, [(_vm.perfilUsuario !== 'usuario-contrato' && _vm.perfilUsuario !== 'usuario' && !_vm.isChart) ? _c('v-avatar', {
    staticClass: "mr-4",
    attrs: {
      "color": "secondary",
      "size": "30"
    }
  }, [_c('avatar-perfil', {
    attrs: {
      "is-fetch": true,
      "usuario": _vm.ticket.usuario
    }
  })], 1) : _vm._e(), _c('v-list-item-content', {
    staticClass: "py-2"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [_c('v-chip', {
    staticClass: "mr-1",
    attrs: {
      "color": _vm.ticket.numeroInformeTecnico && _vm.perfilUsuario !== 'usuario-contrato' && _vm.perfilUsuario !== 'usuario' ? 'success-chip' : 'secondary primary--text',
      "small": "small",
      "label": "label"
    }
  }, [_c('span', {
    staticClass: "font-weight-700 font-size-11"
  }, [_vm._v(_vm._s(_vm.ticket.numero))])]), (_vm.showNumeroInforme) ? _c('v-chip', {
    staticClass: "mx-1",
    attrs: {
      "color": "secondary primary--text",
      "small": "small",
      "label": "label"
    }
  }, [_c('span', {
    staticClass: "font-weight-700 font-size-11"
  }, [_vm._v("IT: " + _vm._s(_vm.ticket.numeroInformeTecnico))])]) : _vm._e(), _c('div', {
    staticClass: "d-flex fd-column text-left"
  }, [(_vm.perfilUsuario === 'dispatcher') ? _c('span', [(_vm.ticket.tipoticket === 'contrato') ? _c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v(_vm._s(_vm.ticket.codigoClienteSap) + " ")]) : _vm._e()]) : _vm._e(), _c('span', {
    staticClass: "font-size-12 font-weight-700"
  }, [_vm._v(_vm._s(_vm.ticket.razonSocial))]), _c('span', {
    staticClass: "font-size-10 text-muted"
  }, [_vm._v(_vm._s(_vm.ticket.usuario))])])], 1)]), _c('v-spacer')], 1), _c('div', {
    staticClass: "d-flex fd-column"
  }, [(_vm.ticket.serie || _vm.ticket.modelo) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "14"
    }
  }, [_vm._v("home_repair_service")]), _c('small', {
    staticClass: "font-size-10 text-muted"
  }, [_vm._v("Serie registrada "), _c('small', {
    staticClass: "font-size-10 font-weight-700 grey--text"
  }, [_vm._v(" " + _vm._s(_vm.ticket.serie) + " ")])]), (_vm.ticket.modelo) ? _c('small', {
    staticClass: "font-size-10 text-muted"
  }, [_vm._v("con modelo "), _c('small', {
    staticClass: "font-size-10 font-weight-700 grey--text"
  }, [_vm._v(" " + _vm._s(_vm.ticket.modelo))])]) : _vm._e()], 1) : _vm._e(), (_vm.ticket.recall && !_vm.isChart) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "14",
      "color": "primary"
    }
  }, [_vm._v("repeat")]), _c('small', {
    staticClass: "font-size-10 text-muted primary--text font-weight-700"
  }, [_vm._v("Cuenta con " + _vm._s(_vm.ticket.recall) + " recall")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil, 'ai-center': !_vm.isMovil
    }
  }, [_c('small', {
    staticClass: "font-size-10 font-weight-700",
    class: _vm.usuarioLogeado !== _vm.ticket.usuarioUltimaActividad ? 'info--text' : 'grey--text'
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "14",
      "color": _vm.usuarioLogeado !== _vm.ticket.usuarioUltimaActividad ? 'info' : ''
    }
  }, [_vm._v("visibility_off")]), _vm._v("Ultima actividad " + _vm._s(_vm._f("now")(_vm.ticket.fechaUltimaActividad)) + " por " + _vm._s(_vm.ticket.nombreUsuarioUltimaActividad))], 1), _c('v-spacer'), (!_vm.isChart) ? _c('small', {
    staticClass: "font-size-10 text-muted font-weight-700"
  }, [_vm._v(" Creado " + _vm._s(_vm._f("now")(_vm.ticket.fechaRegistro)))]) : _vm._e()], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a313020","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_item_ticket_lista.vue
// module id = 496
// module chunks = 1